/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingTagKeysRequest extends models.BillingSummaryBase {
    getFixupPrototypeFunction() { return BillingTagKeysRequest.fixupPrototype; }

    static newInstance(model: Partial<BillingTagKeysRequest>): BillingTagKeysRequest {
        let obj = Object.assign(new BillingTagKeysRequest(), model);
        BillingTagKeysRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingTagKeysRequest>): BillingTagKeysRequest {
        if (!model) return null;
        return BillingTagKeysRequest.newInstance(<BillingTagKeysRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingTagKeysRequest) {
        if (!obj) return;

        models.BillingTagKeysRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingTagKeysRequest): boolean {
        if (models.BillingSummaryBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingTagKeysRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * If set, the subset of keys to return
     */
    tag_keys: Array<string>;

    /**
     * If set, include values, not just keys
     */
    include_values: boolean;

}
